import axios from "api/axiosController";
import { getAccessToken } from "utils/auth";

const suggestionsParentRoute = "/suggestions";

export const fetchSuggestions = async ({ query, sellerId }: { query: string; sellerId: string | null }) => {
  const uri = `${suggestionsParentRoute}/get-suggestions`;
  try {
    const res = await axios.get(uri, {
      headers: { Authorization: `Bearer ${getAccessToken()}` },
      params: { query, sellerId }, // pass query and sellerId as URL query params
    });
    return res.data;
  } catch (e) {
    throw e;
  }
};
